import { useEffect } from "react";
import ExportarReporte from "../../componentes/ExportarReporte/ExportarReporte";
import VentasDetalleTabla from "../../componentes/VentasReportes/VentasDetalleTabla";
import VentasEstados from "../../componentes/VentasReportes/VentasEstados";
import VentasFiltros from "../../componentes/VentasReportes/VentasFiltros";
import VentasKpis from "../../componentes/VentasReportes/VentasKpis";
import VentasRankingChart from "../../componentes/VentasReportes/VentasRankingChart";
import "../../componentes/VentasReportes/ventasReportes.css";
import { enumReporteSeleccionado } from "../../componentes/FuncionesLocales";
import { useStoreHome } from "../Home/useStoreHome";
import { useVentasReportes } from "./useVentasReportes";

const VentasReportes = () => {
  const {
    filtros,
    resumen,
    detalle,
    ranking,
    estados,
    agruparPor,
    cargando,
    opcionesFiltros,
    cargandoOpciones,
    paginas,
    cargarReportes,
    limpiarFiltros,
    cambiarFiltro,
    cambiarPagina,
    cambiarTamanoPagina,
    cambiarAgrupacion,
  } = useVentasReportes();

  const filtrosExportacion = {
    FechaDesde: filtros.FechaDesde,
    FechaHasta: filtros.FechaHasta,
    ClienteId: filtros.ClienteId,
    MercaderiaId: filtros.MercaderiaId,
    OperadorId: filtros.OperadorId,
    Estado: filtros.Estado,
    FormaPago: filtros.FormaPago,
  };

  useEffect(() => {
    useStoreHome.setState({ ReportesSeleccionado: enumReporteSeleccionado.VENTAS });
  }, []);

  return (
    <section className="ventas-reportes" aria-busy={cargando}>
      <span className="ventas-solo-lectores" aria-live="polite">{cargando ? "Actualizando reporte de ventas" : "Reporte de ventas actualizado"}</span>
      <header className="ventas-reportes-header">
        <div><span className="ventas-eyebrow">Reporte comercial</span><h2>Ventas</h2><p>Una vista clara del rendimiento comercial.</p></div>
        <ExportarReporte endpoint="PISeunReportes/VentasResumen" filters={filtrosExportacion} nombre="Resumen de ventas" disabled={cargando} />
      </header>

      <VentasFiltros
        filtros={filtros}
        opciones={opcionesFiltros}
        cargandoOpciones={cargandoOpciones}
        onChange={cambiarFiltro}
        onConsultar={cargarReportes}
        onLimpiar={limpiarFiltros}
        disabled={cargando}
      />
      <VentasKpis resumen={resumen} />

      <div className="ventas-reportes-doble ventas-insights">
        <VentasRankingChart ranking={ranking} agruparPor={agruparPor} onAgrupar={cambiarAgrupacion} disabled={cargando} filters={{ ...filtrosExportacion, AgruparPor: agruparPor, TamanoPagina: filtros.TamanoPagina }} />
        <VentasEstados estados={estados} filters={filtrosExportacion} disabled={cargando} />
      </div>

      <VentasDetalleTabla
        detalle={detalle}
        filtros={filtros}
        paginas={paginas}
        cargando={cargando}
        onPagina={cambiarPagina}
        onTamanoPagina={cambiarTamanoPagina}
        exportFilters={filtrosExportacion}
      />
    </section>
  );
};

export default VentasReportes;
